/* eslint-disable no-shadow */
/* eslint-disable */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useContext } from 'react';
import './certificationMap.scss';
import EditIcon from '../../Assets/images/svg/dar_pencil.svg';
import DisabledEditIcon from '../../Assets/images/svg/dar_pencil_gray.svg';
import DeleteIcon from '../../Assets/images/svg/dar_delete.svg';
import DisabledDeleteIcon from '../../Assets/images/svg/dar_delete_gray.svg';
import MagnifyingGlass from '../../Assets/images/svg/dar_magnifying.svg';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import {
  certificationMapList,
  deleteCertificationMap,
} from '../../Api/request/certificationmap';
import UseAxios from '../../Api/http/http';
import ButtonComponent from '../../Components/Button/button';
import {
  ADD_EDIT_RESPONSE_MESSAGES,
  ADD_EDIT_DIALOG,
  DOWNLOAD,
  CERTIFICATION_MAP,
  CERTIFICATION_MAP_FIELD,
  CERTIFICATION_MAP_HEADER,
  CERTIFICATION_MAP_SUCCESS_MESSAGE,
} from '../../Constants/strings';
import ArrowDropDown from '../../Assets/images/svg/drop-down-arrow.svg';
import SimpleSnackbar from '../../Components/Snackbar/snackbar';
import DeleteDialog from './deleteMap';
import pdfIcon from '../../Assets/images/svg/pdf.svg';
import pdfhoverIcon from '../../Assets/images/svg/pdf_hover.svg';
import excelIcon from '../../Assets/images/svg/excel.svg';
import excelhoverIcon from '../../Assets/images/svg/excel_hover.svg';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
  getCertificationMapDataPdf,
  getMapCertificationDataExcel,
} from '../../Api/request/reports';
import CertificationsMap from './AddEditMap/addEditMap';
import { AuthContext } from '../../Contexts/AuthContext';
import BackButton from '../../Components/BackButton/backButton';
import { useLocation } from 'react-router-dom';
import { MODULE_NAMES } from '../../Constants/modules';
import PuzzleLoader from '../../Assets/images/svg/loading puzzle.gif';

const CertifyMap = () => {
  const [rows, setRows] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [isMobileView, setIsMobileView] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [ispdfHovered, setIspdfHovered] = useState(false);
  const [isexcelHovered, setIsexcelHovered] = useState(false);
  const [addCertificationOpen, setAddCertificationOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [editMappedCertModalOpen, setEditMappedCertModalOpen] = useState(false);
  const [showBackButton, setShowBackButton] = useState(false);
  const [isLaptopView, setIsLaptopView] = useState(false);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const { userProfile } = useContext(AuthContext);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.CERTIFICATION_MAP] || []
    : [];
  const { userSelectedYear } = location.state || {};

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const formatDate = (dateString) => {
    // Handle null, undefined, empty string, or invalid dates
    if (!dateString || dateString === '' || dateString === null || dateString === undefined) {
      return 'N/A';
    }
    
    const date = new Date(dateString);
    if (isNaN(date) || date.getTime() === 0) {
      // Check if the date is invalid or represents epoch (Jan 1, 1970)
      return 'N/A';
    }
    return `${date.toLocaleString('default', { month: 'short' })} ${date.getDate()}, ${date.getFullYear()}`;
  };

  const getCertificationMapData = () => {
    setLoading(true);
    const urlParams = new URLSearchParams(window.location.search);
    const vertical = urlParams.get('vertical');
    const quarter = urlParams.get('quarter');
    const certification = urlParams.get('certification');
    const year = urlParams.get('year');
    UseAxios(certificationMapList(vertical, quarter, certification, year))
      .then((response) => {
        const certifications = response.data.certificationMapDetails.map(
          (certificationmap) => ({
            ...certificationmap,
            USER_ID: certificationmap.userId,
          }),
        );
        setRows(certifications);
        if(location.state?.showToast){
        snackbarOpen(
          CERTIFICATION_MAP_SUCCESS_MESSAGE.message,
          CERTIFICATION_MAP_SUCCESS_MESSAGE.severity
        );
      }
      })
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getCertificationMapData();
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, [location]);
  const checkMobileView = () => {
    setIsMobileView(window.innerWidth < 1024);
    setIsLaptopView(window.innerWidth >= 1024 && window.innerWidth <= 1700);
  };
  const updateCertList = () => {
    getCertificationMapData();
    setSearchText('');
    clearSearchInput();
  };
  const clearSearchInput = () => {
    const searchInput = document.getElementById('certification-search-input');
    if (searchInput) {
      searchInput.value = '';
    }
  };

  useEffect(() => {
    if (location.state?.fromPage) {
      setShowBackButton(true);
    }
  }, [location.state]);

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
  };
  const handleCloseDialog = () => {
    setSelectedItem(null);
  };
  const snackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSeverity(severity);
    setOpenSnackbar(true);
    setTimeout(() => setOpenSnackbar(false), 4000);
  };
  const handleDeleteAction = async (item) => {
    try {
      const config = deleteCertificationMap(item.id);
      const response = await UseAxios(config);
      const message =
        response.data?.message === 'Mapped certificate deleted successfully'
          ? ADD_EDIT_RESPONSE_MESSAGES.DELETE_SUCCESS
          : ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN;
      const severity =
        response.data?.message === 'Mapped certificate deleted successfully'
          ? 'success'
          : 'warning';

      setRows((prevRows) => prevRows.filter((row) => row.id !== item.id));
      snackbarOpen(message, severity);
    } catch (error) {
      snackbarOpen(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN, 'warning');
    } finally {
      handleCloseDialog();
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDownloadPdf = async () => {
    try {
      if (rows.length === 0) {
        snackbarOpen();
        setSnackbarMessage('No data to download');
        setSeverity('warning');
        return;
      }
      await getCertificationMapDataPdf();
    } catch (error) {
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };

  const handleDownloadExcel = async () => {
    try {
      if (rows.length === 0) {
        snackbarOpen();
        setSnackbarMessage('No data to download');
        setSeverity('warning');
        return;
      }
      await getMapCertificationDataExcel();
    } catch (error) {
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };

  const handleEditCertificationClick = async (data) => {
    setEditItem(data);
    setIsEdit(true);
    setEditMappedCertModalOpen(true);
  };

  const handleAddCertificationClick = () => {
    setIsEdit(false);
    setAddCertificationOpen(true);
  };

  const handleAddCertificationClose = () => {
    setAddCertificationOpen(false);
  };

  const handleEditCertificationClose = () => {
    setEditMappedCertModalOpen(false);
  };

  const filteredRows =
    searchText.length >= 1
      ? rows.filter((certificationmap) => {
          const text = searchText.toLowerCase();
          return (
            certificationmap[CERTIFICATION_MAP_FIELD.USER_ID]
              ?.toString()
              .toLowerCase()
              .includes(text) ||
            certificationmap[CERTIFICATION_MAP_FIELD.NAME]
              ?.toLowerCase()
              .includes(text) ||
            certificationmap[CERTIFICATION_MAP_FIELD.EMAIL]
              ?.toLowerCase()
              .includes(text) ||
            certificationmap[CERTIFICATION_MAP_FIELD.VERTICAL]
              ?.toLowerCase()
              .includes(text) ||
            certificationmap[CERTIFICATION_MAP_FIELD.CERTIFICATION_NAME]
              ?.toLowerCase()
              .includes(text) ||
            (certificationmap[CERTIFICATION_MAP_FIELD.EMPLOYEE_STATUS]
              ? 'active'.includes(text)
              : 'exit'.includes(text)) ||
            formatDate(certificationmap[CERTIFICATION_MAP_FIELD.ACHIEVED_DATE])
              .toLowerCase()
              .includes(text) ||
            formatDate(certificationmap[CERTIFICATION_MAP_FIELD.EXPIRY_DATE])
              .toLowerCase()
              .includes(text)
          );
        })
      : rows;

      const getColumnWidth = (mobile, laptop, defaultWidth) => {
        if (isMobileView) {
          return mobile;
        } else if (isLaptopView) {
          return laptop;
        }
        return defaultWidth;
      };
    
      const getColumnFlex = (defaultFlex) => {
        if (!isMobileView && !isLaptopView) {
          return defaultFlex;
        }
        return undefined;
      };   
      
  const columns = [
    {
      field: CERTIFICATION_MAP_FIELD.USER_ID,
      headerName: CERTIFICATION_MAP_HEADER.ID,
      width: getColumnWidth(130, 130, 120),
      flex: getColumnFlex(0.7),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: CERTIFICATION_MAP_FIELD.NAME,
      headerName: CERTIFICATION_MAP_HEADER.NAME,
      width: getColumnWidth(180, 150, 180),
      flex: getColumnFlex(0.75),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: CERTIFICATION_MAP_FIELD.EMAIL,
      headerName: CERTIFICATION_MAP_HEADER.EMAIL,
      width: getColumnWidth(312, 230, 290),
      flex: getColumnFlex(1),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: CERTIFICATION_MAP_FIELD.VERTICAL,
      headerName: CERTIFICATION_MAP_HEADER.VERTICAL,
      width: getColumnWidth(180, 180, 140),
      flex: getColumnFlex(0.8),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: CERTIFICATION_MAP_FIELD.CERTIFICATION_NAME,
      headerName: CERTIFICATION_MAP_HEADER.CERTIFICATION_NAME,
      width: getColumnWidth(369, 240, 240),
      flex: getColumnFlex(1.2),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: CERTIFICATION_MAP_FIELD.ACHIEVED_DATE,
      headerName: CERTIFICATION_MAP_HEADER.ACHIEVED_DATE,
      width: getColumnWidth(182, 182, 200),
      flex: getColumnFlex(1.05),
      sortable: false,
      disableColumnMenu: true,
      valueFormatter: (params) => formatDate(params),
    },
    {
      field: CERTIFICATION_MAP_FIELD.EXPIRY_DATE,
      headerName: CERTIFICATION_MAP_HEADER.Expiry_DATE,
      width: getColumnWidth(163, 163, 180),
      flex: getColumnFlex(0.95),
      sortable: false,
      disableColumnMenu: true,
      valueFormatter: (params) => formatDate(params),
    },
    {
      field: CERTIFICATION_MAP_FIELD.EMPLOYEE_STATUS,
      headerName: CERTIFICATION_MAP_HEADER.Employee_status,
      width: getColumnWidth(197, 200, 200),
      flex: getColumnFlex(1.15),
      sortable: false,
      disableColumnMenu: true,
      valueFormatter: (params) => (params),
    },
  ];

  const mobileColumns = [];
  const desktopColumns = [];
  
  const renderUpdateAndDeleteIcon = (params, isMobileView) => {
    return (
      <div className={isMobileView ? 'mobile-action-icons' : undefined}>
        <button
          disabled={!hasAccess('update')}
          aria-label="Edit"
          className={
            !hasAccess('update')
              ? 'certification-action-edit-icon-disabled'
              : 'certification-action-edit-icon'
          }
          onClick={() => handleEditCertificationClick(params.row)}
          id="certification-map-edit-icon"
        >
          <img
            src={!hasAccess('update') ? DisabledEditIcon : EditIcon}
            alt="Edit"
          />
        </button>

        <button
          id="certification-map-delete-icon"
          disabled={!hasAccess('delete')}
          aria-label="Delete"
          className={
            !hasAccess('delete')
              ? 'certification-action-delete-icon-disabled'
              : 'certification-action-delete-icon'
          }
          onClick={() => handleDeleteClick(params.row)}
        >
          <img
            src={!hasAccess('delete') ? DisabledDeleteIcon : DeleteIcon}
            alt="Delete"
          />
        </button>
      </div>
    )
  };
  
  if (isLaptopView || isMobileView) {
    mobileColumns.push(...columns);
    mobileColumns.push({
      field: 'action',
      headerName: 'Actions',
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      width:  !isMobileView && !isLaptopView ? 130 : undefined,
      minWidth: 120,
      renderCell: (params) => renderUpdateAndDeleteIcon(params, true),
      sortable: false,
      disableColumnMenu: true,
    });
  } else {
    desktopColumns.push(...columns);
    desktopColumns.push(
      {
      headerName: CERTIFICATION_MAP_HEADER.ACTION,
      type: 'number',
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      minWidth: 120,
      flex: !isMobileView && !isLaptopView ? 0.7 : undefined,
      renderCell: (params) => renderUpdateAndDeleteIcon(params, false),
      sortable: false,
      disableColumnMenu: true,
    },
    );
  }

  const sortFilterColumns = columns.map((column) => column.field);

  return (
    <div className="cert-map-outer-layer">
      <div className="certification-map">
        <div className="certification-map-title">
          {showBackButton ? (
            <BackButton
              pageName={CERTIFICATION_MAP}
              isActive={true}
              link="/certifications/overview"
              state={{ userSelectedYear }}
            />
          ) : (
            <span>{CERTIFICATION_MAP}</span>
          )}
        </div>
        <div className="certification-search-and-buttons">
          <div className="certification-search">
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="certification-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </div>
          <div className="certification-button">
            <div className="certi-button-download">
              <ButtonComponent
                id="download-certificate-btn"
                label={DOWNLOAD}
                variant="text"
                onClick={handleDownloadClick}
                endIcon={<img src={ArrowDropDown} alt="Arrow Drop Down" />}
                btnCss="download-certificate-btn"
              />
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem
                  onClick={handleDownloadPdf}
                  className="download-certify-dropdown"
                  onMouseEnter={() => setIspdfHovered(true)}
                  onMouseLeave={() => setIspdfHovered(false)}
                >
                  <img
                    src={ispdfHovered ? pdfhoverIcon : pdfIcon}
                    style={{ marginRight: 8 }}
                    alt="PDF Icon"
                  />{' '}
                  Download as PDF
                </MenuItem>
                <MenuItem
                  onClick={handleDownloadExcel}
                  className="download-certify-dropdown"
                  onMouseEnter={() => setIsexcelHovered(true)}
                  onMouseLeave={() => setIsexcelHovered(false)}
                >
                  <img
                    src={isexcelHovered ? excelhoverIcon : excelIcon}
                    style={{ marginRight: 8 }}
                    alt="excel Icon"
                  />{' '}
                  Download as Excel
                </MenuItem>
              </Menu>
            </div>
            <div>
              <ButtonComponent
                disabled={!hasAccess('create')} // Disable add button based on permission
                id="add-certification-btn"
                label={ADD_EDIT_DIALOG.ADD_MAP}
                variant="contained"
                onClick={() => {
                  handleAddCertificationClick();
                }}
                btnCss={
                  !hasAccess('create')
                    ? 'add-certification-btn-disabled'
                    : 'add-certification-btn'
                }
              />
            </div>
          </div>
        </div>
        <div className="button">
          <CertificationsMap
            modalOpen={isEdit ? editMappedCertModalOpen : addCertificationOpen}
            setIsEdit={setIsEdit}
            handleClose={
              isEdit
                ? handleEditCertificationClose
                : handleAddCertificationClose
            }
            setRows={isEdit ? setRows : updateCertList}
            isEditMode={isEdit}
            editItem={isEdit ? editItem : null}
          />
        </div>
        <div className="certificate-data-grid-container">
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
              <img
                src={PuzzleLoader}
                alt="Loading..."
                className="loader-gif"
                style={{ width: '100px', height: 'auto' }}
              />
            </div>
          ) : (
            filteredRows && (
              <DataGridComponent
                dataRows={filteredRows}
                dataColumns={isMobileView || isLaptopView ? mobileColumns : desktopColumns}
                isFilteredRows={filteredRows}
                sortFilterColumns={sortFilterColumns}
                pageSize={10}
                isEdit={isEdit}
              />
            )
          )}
        </div>
      </div>
      <SimpleSnackbar
        open={openSnackbar}
        message={snackbarMessage}
        severity={severity}
        alertCss={`certification-snackbar ${severity}`}
      />
      <DeleteDialog
        handleCloseAction={handleCloseDialog}
        selectedItem={selectedItem}
        handleDeleteAction={handleDeleteAction}
        setRows={setRows}
        handleSnackbar={snackbarOpen}
      />
    </div>
  );
};
export default CertifyMap;
